import { useNavigate } from "react-router-dom";
import { getGlobalSetAuth, useAuth } from "../context/AuthProvider";

// src/lib/logout.ts
export function useLogout() {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const basePath = window.location.pathname.split('/')[1]; // "test-mountq" or ""

  return () => {
    // Clear local auth-related state
    setAuth({ status: 'unauthenticated', data: null });
    
    document.cookie = `mq-token=; Max-Age=0; path=/${basePath};`;

    // React-native redirect
    navigate('/login', { replace: true });
    
  }
}

export function logoutFromInterceptor() {
  const setAuth = getGlobalSetAuth();

  if (setAuth) {
    setAuth({ status: 'unauthenticated', data: null });
  }

  const basePath = window.location.pathname.split('/')[1];
  document.cookie = `mq-token=; Max-Age=0; path=/${basePath};`;

  // Optional: soft redirect after short delay
  setTimeout(() => {
    const redirect = basePath ? `/${basePath}/#/login` : '#/login';
    window.location.href = redirect;
  }, 50);
}
